
































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import AppIconTextButton from "@/components/_shared/buttons/app-icon-text-button.vue";
import { orderApiProvider } from "@/providers/order-api-provider";
import AddressFormComponent from "@/components/_shared/forms/address-form-component.vue";
import { Order, OrderStatus } from "@/interfaces/order";
import OrderSelectedStockGrid from "@/components/order/order-selected-stock-grid.vue";
import OrderSelectedPackingGrid from "@/components/order/order-selected-packing-grid.vue";
import ContactSearchComponent from "@/components/_shared/searchs/contact-search-component.vue";
import router from "@/router/router";
import moment from "moment";
import {DocumentOrigin} from "@/interfaces/document";
import DocumentDetailList from "@/components/document/document-detail-list.vue";

@Component({
  name: "order-list-page",
  computed: {
    DocumentOrigin() {
      return DocumentOrigin
    },
    OrderStatus() {
      return OrderStatus;
    },
  },
  components: {
    OrderSelectedStockGrid,
    AppIconTextButton,
    AddressFormComponent,
    ContactSearchComponent,
    OrderSelectedPackingGrid,
    DocumentDetailList
  },
})
export default class OrderDetailPage extends Vue {
  order: Order | null = null;
  loadingPdf = false;

  get deliveryDate() {
    return moment(this.order.deliveryDate).format("L");
  }

  get appointmentDate() {
    return moment(this.order.appointmentDate).format("L");
  }

  async downloadPdf() {
    this.loadingPdf = true;
    const pdfContent = await orderApiProvider.getPdf(this.$route.params.order_id);

    const linkSource = `data:application/pdf;base64,${pdfContent}`;
    const downloadLink = document.createElement("a");
    const fileName = `Commande ${this.order.reference}.pdf`;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();

    this.loadingPdf = false;
  }

  getBottleCount() {
    return this.order.stocks.reduce((accumulator, stock) => {
      return accumulator + stock.ordered;
    }, 0);
  }

  async beforeMount() {
    // Récupérer la commande
    this.order = await orderApiProvider.getOrder(this.$route.params.order_id);

    if (this.order) {
      // Ajouter les clés uniques pour chaque stock
      this.order.stocks = this.order.stocks.map((stock, index) => ({
        ...stock,
        uniqueKey: `${stock.id}-${stock.ordered}-${index}`, // Génération d'une clé unique
      }));

      // Émettre un événement pour mettre à jour le titre de la page
      this.$eventHub.$emit(
        "update-title",
        this.$t("order.detail_page_title", { code: this.order.reference })
      );

      // Ajouter la référence à la navigation
      this.breadcrumbs.push({
        text: this.$t("order.detail_page_title", { code: this.order.reference }),
      });
    } else {
      // Si la commande n'existe pas, rediriger vers la page 404
      await router.push("/404");
    }

    // Récupérer le transporteur et le service associés à la commande
    const carrier = await orderApiProvider.getCarrier(this.$route.params.order_id);
    const service = await orderApiProvider.getService(this.$route.params.order_id);
    this.order.carrier = carrier;
    this.order.service = service;
  }

  breadcrumbs = [
    { text: this.$t("app.title") },
    { text: this.$t("order.list_page_title"), href: "/order/list" },
  ];

  $refs: {
    orderDetailModal: HTMLFormElement;
  };
}
